import API from './jsonapi-constants'

export const CONSTANTS = {
  TYPE: {
    LIST: 'contactdata/contacts',
    ITEM: 'contactdata/contact',
  },
  ATTRIBUTE: {
    COUNTRY: 'country',
    REGION: 'region',
    BRAND: 'brand',
    ROLE: 'role',
    PHONE: 'phone',
    CONTACT_NAME: 'contact_name',
    CONTACT_EMAIL: 'contact_email',
    CONTACT_PHONE: 'contact_phone',
    CONTACT_OPENING_HOURS: 'contact_opening_hours',
  },
}

export const PATHS = {
  COUNTRY: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.COUNTRY],
  REGION: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.REGION],
  BRAND: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.BRAND],
  ROLE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ROLE],
  PHONE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.PHONE],
  CONTACT_NAME: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CONTACT_NAME],
  CONTACT_EMAIL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CONTACT_EMAIL],
  CONTACT_PHONE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CONTACT_PHONE],
  CONTACT_OPENING_HOURS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CONTACT_OPENING_HOURS],
}

export default {
  ...CONSTANTS,
  PATHS,
}
